/*---------------------------------------------------------------------------------------------
 *  Copyright (c) by Solusek Systems. All rights reserved.
 *--------------------------------------------------------------------------------------------*/
 
 import BaseComponent from "./BaseCom";
import FormInput from "./FormInput";
import { v4 as uuidv4 } from 'uuid';
import FormLabel from "./FormLabel";
import WoundCapture from "./WoundCapture";
import { qreq } from "../shared/qrequest";
import Globals from "../shared/Globals";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import * as fa from '@fortawesome/free-solid-svg-icons'
import Alert from "./Alert";
import React from "react";

export default class Wound extends BaseComponent {
    constructor(props) {
        super(props);
        this.state = {
            item: props.item,
            showUploadButton: false,
            edit: props.edit,
            allowEdit: props.allowEdit,
            showCapture: false,
            visit: props.visit
        };
        this.id = uuidv4();
        this.selectUpload = this.selectUpload.bind(this);
        this.cancelUpload = this.cancelUpload.bind(this);
        this.upload = this.upload.bind(this);
        this.save = this.save.bind(this);
        this.remove = this.remove.bind(this);
        this.uploadRef = React.createRef();
    }

    componentDidUpdate(prevProps) {
        if (prevProps.item !== this.props.item) {
            this.setState({ item: this.props.item });
        }
        if (prevProps.edit !== this.props.edit) {
            this.setState({ edit: this.props.edit });
        }
        if (prevProps.allowEdit !== this.props.allowEdit) {
            this.setState({ allowEdit: this.props.allowEdit });
        }
        if (prevProps.visit !== this.props.visit) {
            this.setState({ visit: this.props.visit });
        }
    }

    selectUpload() {
        this.uploadRef.current.click();
    }

    cancelUpload() {
        this.setState({ showCapture: false });
    }

    upload(e) {
        this.setState({ uploading: true });
        var reader = new FileReader();
        reader.readAsBinaryString(e.target.files[0]);
        reader.onload = () => {
            var b64data = btoa(reader.result);
            var item = this.state.item;
            item.fileName = e.target.files[0].name;
            item.mimeType = e.target.files[0].type;
            item.dataSize = e.target.files[0].size;
            item.base64Content = b64data;
            item.visitID = this.state.visit.id;
            item.orderID = this.state.visit.orderID;
            qreq.post('/api/wound/save', item, j => {
                if (j.errorCode === 0) {
                    j.item.base64Content = null;
                    this.setState({ uploading: false, item: j.item });
                }
                else {
                    this.alert(j.errorMessage);
                    this.setState({ uploading: false });
                }
                e.target.value = '';
            }, () => {
                this.alert('Unknown error ocurred. Please try again.');
                this.setState({ uploading: false });
                e.target.value = '';
            });
        };
        reader.onerror = (error) => {
            console.log('Error: ', error);
            this.setState({ uploading: false });
            e.target.value = '';
        };

    }

    save() {
        var item = this.state.item;
        if (!item.id) {
            this.alert('Please upload a Wound Image first.');
            return;
        }
        this.setState({ saving: true });
        qreq.post('/api/wound/save', item, j => {
            if (j.errorCode === 0) {
                this.setState({ edit: false, item: j.item });
            }
            else {
                this.alert(j.errorMessage);
            }
            this.setState({ saving: false });
        }, () => {
            this.alert('Unknown error ocurred. Please try again.');
            this.setState({ saving: false });
        });
    }

    remove(obj) {
        if(!window.confirm('Are you sure you want to remove this wound?'))
            return;
        this.props.remove(obj);
    }

    render() {
        return (<div className="card mb-3">
            <input ref={this.uploadRef} type="file" className="d-none" id={'c-uploader-' + this.id} accept="image/*" capture="camera" onChange={this.upload} />
            {this.state.showCapture ? <WoundCapture onCancel={this.cancelUpload} /> :
            <div style={{ position: 'relative' }} onMouseOver={(e) => this.setState({ showUploadButton: true })} onMouseOut={(e) => this.setState({ showUploadButton: false })}>
                    {this.state.edit && this.state.showUploadButton ? (<div className="text-center" style={{ position: 'absolute', top: '45%', width: '100%' }}>
                        <button type="button" onClick={this.selectUpload} className="btn btn-primary" disabled={this.state.uploading}><L>Capture or Upload Photo</L></button>
                    </div>) : ''}
                    {this.state.item.fileIdent ? <img src={Globals.serverUrl + '/api/wound/image/' + this.state.item.fileIdent} className="card-img-top" alt="" /> :
                        <img src="/img/placeholder.png" className="card-img-top" alt="" />}
            </div>}
            <div className="card-body">
                {this.state.edit ? <>
                    {this.state.uploading ? <Alert message="Uploading..." /> : ''}
                    <div className="row">
                        <div className="col"><FormInput model={this.state.item} label="L (cm)" name="sizeLength" type="number" required={true} disabled={this.state.uploading || !this.state.item.id} /></div>
                        <div className="col"><FormInput model={this.state.item} label="W (cm)" name="sizeWidth" type="number" required={true} disabled={this.state.uploading || !this.state.item.id} /></div>
                    </div>
                    <FormInput model={this.state.item} label="Notes" name="notes" type="text" required={false} disabled={this.state.uploading || !this.state.item.id} />
                    <div className="btn-group d-grid">
                        <button type="button" className="btn btn-success" onClick={this.save} disabled={this.state.saving}><FontAwesomeIcon icon={fa.faSave} /><L>Save Wound Info</L></button>
                    </div>
                </> : <>
                    <FormLabel model={this.state.item.size} label="Wound Size" name="size" type="text" required={true} />
                        <FormLabel model={this.state.item.notes} label="Notes" name="notes" type="text" required={false} />
                        {this.state.allowEdit ?
                            <div className="d-grid gap-2">
                                <button type="button" className="btn btn-secondary" onClick={() => this.setState({ edit: true })}><FontAwesomeIcon icon={fa.faPencil} /><L>Edit Wound Info</L></button>
                                {this.props.remove ? <button type="button" className="btn btn-danger" onClick={() => this.remove(this.state.item)}><FontAwesomeIcon icon={fa.faPencil} /><L>Remove Wound</L></button> : ''}
                            </div> : ''}
                </>}
            </div>
        </div>)
    }
}